import {
  employeeDirectoryFiltersSchema,
  type EmployeeDirectoryFilters,
} from "@evolua/schemas";

/** Lê filtros do diretório a partir da query string. */
export function parseEmployeeDirectorySearch(
  params: URLSearchParams,
): EmployeeDirectoryFilters {
  const raw = {
    ...(params.get("status")
      ? { status: params.get("status") as EmployeeDirectoryFilters["status"] }
      : {}),
    ...(params.get("sort")
      ? { sort: params.get("sort") as EmployeeDirectoryFilters["sort"] }
      : {}),
    ...(params.get("q") ? { q: params.get("q")! } : {}),
  };
  const parsed = employeeDirectoryFiltersSchema.safeParse(raw);
  if (!parsed.success) {
    return { sort: "fullName:asc" };
  }
  return parsed.data;
}

/** Escreve filtros na URL (omitindo defaults). */
export function employeeDirectoryToSearchParams(
  filters: EmployeeDirectoryFilters,
): URLSearchParams {
  const next = new URLSearchParams();
  if (filters.status) next.set("status", filters.status);
  if (filters.q) next.set("q", filters.q);
  if (filters.sort && filters.sort !== "fullName:asc") {
    next.set("sort", filters.sort);
  }
  return next;
}
